import {
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  CREATE_CUSTOMER_REQUEST,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  UPDATE_CURRENT_PROJECT_ID
} from '../actions/customerActions';

const customerInitialState = {
  customers: [],
  loading: false,
  error: null,
  currentProjectId: null,
};

const customerReducer = (state = customerInitialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMERS_REQUEST:
      return { ...state, loading: true };
    case FETCH_CUSTOMERS_SUCCESS:
      return { ...state, loading: false, customers: action.payload };
    case FETCH_CUSTOMERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_CUSTOMER_REQUEST:
      return { ...state, loading: true };
    case CREATE_CUSTOMER_SUCCESS:
      return { ...state, loading: false, customers: [...state.customers, action.payload] };
    case CREATE_CUSTOMER_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case UPDATE_CURRENT_PROJECT_ID:
        return { ...state, currentProjectId: action.payload };
    default:
      return state;
  }
};

export default customerReducer;
